import { helpers, required } from '@vuelidate/validators';

/**
 * Client rules for a staff role request (RequestRoleInput). Shared by the
 * Teachers "Request Staff Role" dialog and My Account "Request a Role".
 */
export const roleRequestRules = {
  school_permission_group_id: {
    required: helpers.withMessage('Choose the role you are requesting.', required),
  },
};
